import { useMemo } from 'react';
import { useConfig } from '../../config/config.hook';
import { useMatricula } from '../../matricula/matricula.hook';
import { TipoEvento } from '../datalayer.types';
import { imprimirLog } from '../imprimir-log.datalayer';
import { DataLayerGenericEvent } from './datalayer-generic-event.types';

function slugify(text: string): string {
  return (
    text &&
    text
      .toString()
      .toLowerCase()
      .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a')
      .replace(/[èÈéÉêÊëË]+/g, 'e')
      .replace(/[ìÌíÍîÎïÏ]+/g, 'i')
      .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o')
      .replace(/[ùÙúÚûÛüÜ]+/g, 'u')
      .replace(/[ýÝÿŸ]+/g, 'y')
      .replace(/[ñÑ]+/g, 'n')
      .replace(/[çÇ]+/g, 'c')
      .replace(/ß+/g, 'ss')
      .replace(/[Ææ]+/g, 'ae')
      .replace(/[Øøœ]+/g, 'oe')
      .replace(/%+/g, '')
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '')
  );
}

const aplicarTratamentoSlugify = (dados: string[]) => dados.map((item) => slugify(item)).join(':');

export const useDataLayerEventGeneric = (): DataLayerGenericEvent => {
  const { brand } = useConfig();
  const matricula = useMatricula();

  const genericEventDefaultFields = useMemo<{ event: TipoEvento }>(
    () => ({
      event: 'event',
    }),
    [],
  );

  return {
    push: ({ eventAction, eventLabel, eventCategory, feature }) => {
      const marca = brand;
      const perfilUsuario = matricula.getSelecionada() ? 'aluno' : 'educador';
      const eventCategoryFormatado = eventCategory?.length > 0 ? eventCategory : ['aura', marca, perfilUsuario];

      if (feature) {
        eventCategoryFormatado.push(feature);
      }

      genericEventDefaultFields['eventCategory'] = aplicarTratamentoSlugify(eventCategoryFormatado);
      genericEventDefaultFields['eventAction'] = aplicarTratamentoSlugify(eventAction);
      genericEventDefaultFields['eventLabel'] = aplicarTratamentoSlugify(eventLabel);

      imprimirLog({ tipoEvento: 'event', dados: genericEventDefaultFields });

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any)?.dataLayer?.push(genericEventDefaultFields);
    },
  };
};
